export default __webpack_public_path__ + "d6bcaf563bad6753e69de0f35a65f329.png";